import i18n from 'i18next';
import { Helmet } from '@dr.pogodin/react-helmet';
import { useLocation } from 'react-router';
import { FC } from 'react';
import {
  SUPPORTED_LANGUAGE_PATH_ROOTS,
  setPathLocale
} from '../../common/localeShared';

export const LocationMetaTags: FC<any> = (props: any) => {
  const location = useLocation();

  return (
    <Helmet>
      {SUPPORTED_LANGUAGE_PATH_ROOTS.map((code) => (
        <link
          key={code}
          rel="alternate"
          hrefLang={code}
          href={`${RIO_SITE.external_url}${setPathLocale(location.pathname, code)}`}
        />
      ))}

      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${RIO_SITE.external_url}${setPathLocale(location.pathname, 'en')}`}
      />

      <link rel="canonical" href={`${RIO_SITE.external_url}${setPathLocale(location.pathname, i18n.language)}`} />
    </Helmet>
  );
};
